export default __webpack_public_path__ + "static/media/rar.a57c80aa.svg";